<template>
	<div class="showcase-item" v-waypoint="{ active: true, callback: scrolling, options: intersectionOptions }">
		<b-container fluid class="showcase-item p-0">
			<b-row no-gutters class="showcase-row" :class="['-' + itemData.key_parity, '-' + itemData.key_number]">
				<b-col cols="12" lg="6" :order-lg="itemData.info.order" class="showcase-info">
					<b-img ref="infoImage" :src="infoImage" :alt="itemData.info.title" fluid class="info-image"></b-img>
					<div ref="infoContainer" class="info-container">
						<h3 v-animate-onscroll="animateClass">{{ itemData.info.title }}</h3>
						<h4 v-animate-onscroll="animateClass">{{ itemData.info.subtitle }}</h4>
						<p v-animate-onscroll="animateClass" class="lead mb-0">{{ itemData.info.description }}</p>
					</div>
				</b-col>
				<b-col cols="12" lg="6" :order-lg="itemData.video.order" class="showcase-video">
					<b-img
						ref="videoImage"
						:src="videoImage"
						:alt="itemData.info.title"
						fluid
						class="video-image"
					></b-img>
					<div ref="videoContainer" class="video-container">
						<vue-plyr ref="plyr" v-if="isVideoLocal" key="plyr-local">
							<video controls crossorigin playsinline :poster="videoImage" @play="playing">
								<source :src="videoMp4" type="video/mp4" />
								<source :src="videoWebm" type="video/webm" />
							</video>
						</vue-plyr>
						<vue-plyr ref="plyr" v-if="isVideoVimeo" key="plyr-vimeo">
							<div @play="playing" class="plyr__video-embed">
								<iframe :src="videoVimeo"></iframe>
							</div>
						</vue-plyr>
					</div>
					<FAIcon icon="play" size="4x" ref="playButton" @click="play" class="play-buttom" />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr)

export default {
	name: 'ShowcaseItem',

	props: {
		itemData: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			intersectionOptions: {
				root: null,
				rootMargin: '0px',
				threshold: [0, 1]
			}
		}
	},

	computed: {
		infoImage() {
			return require('@/assets/media/showcase/' + this.itemData.info.image)
		},
		videoImage() {
			return require('@/assets/media/showcase/' + this.itemData.video.image)
		},
		isVideoLocal() {
			return this.itemData.video.type === 'local'
		},
		videoMp4() {
			return this.isVideoLocal ? require('@/assets/media/showcase/' + this.itemData.video.data.file_mp4) : ''
		},
		videoWebm() {
			return this.isVideoLocal ? require('@/assets/media/showcase/' + this.itemData.video.data.file_webm) : ''
		},
		isVideoVimeo() {
			return this.itemData.video.type === 'vimeo'
		},
		videoVimeo() {
			const configVimeo = [
				'loop=false',
				'byline=false',
				'portrait=false',
				'title=false',
				'speed=true',
				'transparent=false',
				'playsinline=true'
			]
			return this.isVideoVimeo
				? 'https://player.vimeo.com/video/' + this.itemData.video.data.id + '?' + configVimeo.join('&amp;')
				: ''
		},
		animateClass() {
			let animateClass = 'animate__animated '

			if (this.itemData.key_parity === 'odd') {
				animateClass += 'animate__fadeInLeft'
			} else if (this.itemData.key_parity === 'even') {
				animateClass += 'animate__fadeInRight'
			}

			return animateClass
		}
	},

	mounted() {
		this.$store.dispatch('showcase/addPlyr', [this.$refs.plyr])
	},

	methods: {
		play() {
			this.$refs.plyr.player.play()
			this.$refs.playButton.classList.add('-hidden')
			this.$refs.videoImage.classList.add('-hidden')
			this.$refs.infoImage.classList.add('-shown')
			setTimeout(() => this.$refs.infoContainer.classList.add('-playing'), 500)
		},
		playing() {
			const players = [...this.$store.getters['showcase/plyrs']]
			const index = players.indexOf(this.$refs.plyr)

			if (index > -1) {
				players.splice(index, 1)
			}

			players.forEach(player => {
				if (player.player.playing) {
					player.player.pause()
				}
			})
		},
		scrolling({ going }) {
			let goingOut = going === this.$waypointMap.GOING_OUT
			if (goingOut && !this.$refs.plyr.player.paused) {
				this.$refs.plyr.player.pause()
			}
		}
	}
}
</script>
